import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { ArrowLeft, User, MessageSquare, FileText, Heart, Calendar } from "lucide-react";
import api from "../lib/api";

const Profile = () => {
  const { username } = useParams();
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api
      .get(`/profile/${encodeURIComponent(username)}`)
      .then(({ data }) => setProfile(data))
      .catch(() => setError("Profile not found."));
  }, [username]);

  const joined = profile?.joined ? new Date(profile.joined).toLocaleDateString() : "";

  return (
    <div className="mx-auto max-w-3xl px-4 py-14 md:px-8">
      <button
        onClick={() => navigate(-1)}
        className="mb-8 inline-flex items-center gap-2 font-display text-sm uppercase tracking-wide text-[#e0574c] transition-colors hover:text-[#e0a82e]"
      >
        <ArrowLeft className="h-4 w-4" /> Back
      </button>

      {error && <p className="text-[#f08a80]">{error}</p>}

      {profile && (
        <>
          <div className="flex items-center gap-4">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-[#e0a82e] text-[#1c1c1c]">
              <User className="h-8 w-8" />
            </div>
            <div>
              <h1 className="font-display text-3xl font-700 uppercase tracking-wide text-[#e0a82e]">
                {profile.username}
              </h1>
              {joined && (
                <p className="mt-1 flex items-center gap-1 text-sm text-[#9a9a9a]">
                  <Calendar className="h-3 w-3" /> Member since {joined}
                </p>
              )}
            </div>
          </div>

          <div className="mt-6 grid grid-cols-2 gap-4">
            <div className="rounded-md border border-white/10 bg-[#242424] p-5 text-center">
              <FileText className="mx-auto h-6 w-6 text-[#e0a82e]" />
              <p className="mt-2 font-display text-2xl text-[#f0f0f0]">{profile.topicCount}</p>
              <p className="text-xs uppercase tracking-wide text-[#9a9a9a]">Topics</p>
            </div>
            <div className="rounded-md border border-white/10 bg-[#242424] p-5 text-center">
              <MessageSquare className="mx-auto h-6 w-6 text-[#e0a82e]" />
              <p className="mt-2 font-display text-2xl text-[#f0f0f0]">{profile.replyCount}</p>
              <p className="text-xs uppercase tracking-wide text-[#9a9a9a]">Replies</p>
            </div>
          </div>

          <h2 className="mt-10 font-display text-lg uppercase tracking-wide text-[#e0574c]">Topics started</h2>
          <div className="mt-4 space-y-3">
            {profile.topics.length === 0 && (
              <p className="text-sm text-[#9a9a9a]">No topics yet.</p>
            )}
            {profile.topics.map((t) => (
              <Link
                key={t.id}
                to="/community"
                className="block rounded-md border border-white/10 bg-[#242424] p-4 transition-colors hover:border-[#e0a82e]/50"
              >
                <span className="font-display text-xs uppercase tracking-widest text-[#e0574c]">{t.category}</span>
                <h3 className="mt-1 font-display text-lg text-[#f0f0f0]">{t.title}</h3>
                <div className="mt-2 flex items-center gap-3 text-xs text-[#8f8f8f]">
                  <span>{new Date(t.createdAt).toLocaleDateString()}</span>
                  <span className="flex items-center gap-1"><Heart className="h-3 w-3" /> {t.likes}</span>
                </div>
              </Link>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Profile;
